// extracted by mini-css-extract-plugin
module.exports = {"APR":"Snippet_APR__yfiHg","phoneNumber":"Snippet_phoneNumber__DdDqv"};